export async function schoolRequest(url, body = {}) {
  const response = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || !payload.status) throw new Error(payload.message || 'Unable to complete the request.');
  return payload;
}
